import { api } from "./api";

export const apiCustomer = {
  getCustomers: (filter, page, size = 10) =>
    api.post("web/member-customers/filter-admin-customers", {
      filter,
      page,
      size,
    }),

  editCustomer: (params) => {
    return api.put("web/customers/edit", { ...params });
  },

  getMemberSuggest: (params = {}) => {
    return api.get(
      "web/member-customers/suggest_user_member_customer_code",
      params
    );
  },

  createOrEditEnterpriseCustomer: (params) => {
    return api.post("web/customers/enterprise/create_or_update", { ...params });
  },

  createPersonalCustomer: (params) => {
    return api.post("web/customers/individual/create", { ...params });
  },

  editPersonalCustomer: (params) => {
    return api.put("web/customers/individual/edit", { ...params });
  },

  memberCustomerSuggest: (filter, page, size = 10) => {
    ///member-customers/filter
    return api.post("web/member-customers/filter", { filter, page, size });
  },

  customerSuggest: (filter, page, size = 10) => {
    ///member-customers/filter
    return api.post("web/customers/filter", { filter, page, size });
  },
  // token

  getCustomerEnterpriseDetail: (id) => {
    return api.get(`web/member-customers/${id}`);
  },

  getCustomerPersonalDetail: (id) => {
    return api.get(`web/customers/${id}`);
  },

  deleteCustomerEnterprise: (id) => {
    return api.delete(`web/member-customers/delete/${id}`);
  },

  deleteCustomerPersonal: (id) => {
    return api.delete(`web/customers/individual/delete/${id}`);
  },

  exportCustomer: (filter, page, size, fileName = "Danh sách khách hàng") =>
    api.postExcel("web/export/customers", { filter, page, size, fileName }),

  getIndividualCustomerName: () =>
    api.get("web/customers/suggest_customer_code"),

  getEnterpriseCustomerName: () =>
    api.get("web/member-customers/suggest_member_customer_code"),

  getSuggestMember: (params) =>
    api.get("web/member-customers/suggestion-member-customer-ignore", params),
};
